import CampaignConversionsNoResult from './campaignConversions';

export default CampaignConversionsNoResult;